import React from "react";
import { Background } from "../../../BuildingBlocks/Background";
import { FrontColors } from "../../../../models/FrontColors";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { Padding } from "../../../BuildingBlocks/Padding";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { FrontIcon } from "../../../Front/Simple/FrontIcon/FrontIcon";
import { FontRobotoSlab } from "../../../BuildingBlocks/FontRobotoSlab";
import { FontSize } from "../../../BuildingBlocks/FontSize";
import { FrontFontSizes } from "../../../../models/FrontFontSizes";
import { TextColor } from "../../../BuildingBlocks/TextColor";

export const FPMarketingHelplineCTASuccess = (props: {
    coloursInverted?: boolean,
}): JSX.Element => {
    const coloursInverted = props.coloursInverted || false;

    const backgroundColour =
        coloursInverted
            ? FrontColors.NEUTRAL_18
            : FrontColors.PROBATE_0;

    const textColour =
        coloursInverted
            ? FrontColors.NEUTRAL_0
            : FrontColors.NEUTRAL_18;

    const iconColour =
        coloursInverted
            ? "neutral-0"
            : "neutral-18";

    return <Background
        width="100%"
        borderRadius="5px"
        color={backgroundColour}
    >
        <Padding spacing={`${FrontSpacing.SMALL_3} ${FrontSpacing.MEDIUM_1}`}>
            <SpacingRow
                justifyContent="space-between"
                alignItems="center"
                spacing={FrontSpacing.MEDIUM_1}
            >
                {/* TEXT */}
                <FontRobotoSlab>
                    <FontSize
                        size={FrontFontSizes.SMALL}
                        lineHeight="1.5"
                    >
                        <TextColor color={textColour}>
                            Thank you for entering your number, we will call you soon.
                        </TextColor>
                    </FontSize>
                </FontRobotoSlab>

                {/* ICON */}
                <FrontIcon
                    iconName="flare"
                    size="extra-large"
                    colour={iconColour}
                />
            </SpacingRow>
        </Padding>
    </Background>;
};
